// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var ReactGa = require("react-ga");
var Relude_IO = require("relude/src/Relude_IO.bs.js");
var UrlHelpers = require("../../../shared/src/UrlHelpers.bs.js");

function initialize(googleAnalyticsId) {
  return Relude_IO.suspend(function (param) {
              ReactGa.initialize(googleAnalyticsId);
              
            });
}

function pageview(path) {
  return Relude_IO.suspend(function (param) {
              ReactGa.pageview(UrlHelpers.UrlParts.toUrl(path));
              
            });
}

exports.initialize = initialize;
exports.pageview = pageview;
/* react-ga Not a pure module */
